import type { AuthState, BruteForceState } from '../types/auth.types';

import {
  getToken,
  getRefreshToken,
  getUser,
  clearTokens,
  clearLocalUser,
  isTokenExpired,
} from './token';

const initialBruteForceState: BruteForceState = {
  failedAttempts: 0,
  lastFailedAttempt: null,
  isLocked: false,
  lockUntil: null,
};

/**
 * Khôi phục phiên từ storage: token hết hạn hoặc thiếu user đi kèm → coi như chưa đăng nhập và dọn storage.
 */
export function createInitialAuthState(): AuthState {
  const token = getToken();
  const user = getUser();

  if (!token) {
    return {
      user: null,
      token: null,
      refreshToken: getRefreshToken(),
      isAuthenticated: false,
      isLoading: false,
      bruteForce: initialBruteForceState,
    };
  }

  if (isTokenExpired(token)) {
    clearTokens();
    clearLocalUser();
    return {
      user: null,
      token: null,
      refreshToken: null,
      isAuthenticated: false,
      isLoading: false,
      bruteForce: initialBruteForceState,
    };
  }

  if (!user) {
    clearTokens();
    return {
      user: null,
      token: null,
      refreshToken: getRefreshToken(),
      isAuthenticated: false,
      isLoading: false,
      bruteForce: initialBruteForceState,
    };
  }

  return {
    user,
    token,
    refreshToken: getRefreshToken(),
    isAuthenticated: true,
    isLoading: false,
    bruteForce: initialBruteForceState,
  };
}
